// Maps Configuration
// Google Maps: https://console.cloud.google.com/
// Mapbox: https://account.mapbox.com/

export const GOOGLE_MAPS_CONFIG = {
  // Add your Google Maps API key here
  // For development, you can use a restricted key for localhost
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCcVCn0nYXvrm9Q8gHaz2cNji-Ty1u27dE',
  
  // Map ID for 3D photorealistic tiles (create at Google Cloud Console > Google Maps Platform > Map Management)
  // Leave empty to use default 2D styling. Get a map ID with "3D" or "Photorealistic" enabled
  mapId: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || '',
  
  // Default map center (San Francisco)
  defaultCenter: {
    latitude: 37.78825,
    longitude: -122.4324,
  },
  
  // Default zoom levels
  defaultZoom: 15,
  defaultDelta: 0.05,
  
  // 3D view settings
  default3DTilt: 45,
  default3DHeading: 0,
};

export const MAPBOX_CONFIG = {
  // Add your Mapbox access token here
  // Get one at: https://account.mapbox.com/access-tokens/
  accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || '',
  
  // Map styles
  styles: {
    // Dark style with 3D buildings
    dark: 'mapbox://styles/mapbox/dark-v11',
    // Light style
    light: 'mapbox://styles/mapbox/light-v11',
    // Satellite with labels
    satellite: 'mapbox://styles/mapbox/satellite-streets-v12',
    // 3D standard style (includes 3D buildings and terrain)
    standard: 'mapbox://styles/mapbox/standard',
  },
  
  // Default settings
  defaultZoom: 15,
  
  // 3D settings
  default3DPitch: 60, // Camera angle (0 = looking straight down, 60 = tilted)
  default3DBearing: 0, // Map rotation
  
  // Enable 3D terrain by default
  terrainExaggeration: 1.5, // How much to exaggerate terrain height
};

// Common default center (used by both providers)
export const DEFAULT_CENTER = {
  latitude: 37.78825,
  longitude: -122.4324,
};

/**
 * Check if a location is inside the privacy zone
 * Privacy zone is defined by environment variables:
 * - REACT_APP_PRIVACY_ZONE_LAT: Center latitude
 * - REACT_APP_PRIVACY_ZONE_LNG: Center longitude
 * - REACT_APP_PRIVACY_ZONE_RADIUS_KM: Radius in kilometers
 * 
 * If any value is missing or invalid, the privacy zone is disabled (returns false)
 * 
 * @param {number} latitude - Latitude to check
 * @param {number} longitude - Longitude to check
 * @returns {boolean} True if the location is inside the privacy zone
 */
export const isInsidePrivacyZone = (latitude, longitude) => {
  // Get privacy zone config from environment variables
  const zoneLat = parseFloat(process.env.REACT_APP_PRIVACY_ZONE_LAT);
  const zoneLng = parseFloat(process.env.REACT_APP_PRIVACY_ZONE_LNG);
  const zoneRadiusKm = parseFloat(process.env.REACT_APP_PRIVACY_ZONE_RADIUS_KM);

  // If any value is missing or invalid, privacy zone is disabled
  if (
    isNaN(zoneLat) ||
    isNaN(zoneLng) ||
    isNaN(zoneRadiusKm) ||
    zoneRadiusKm <= 0
  ) {
    return false;
  }

  // Validate input coordinates
  if (typeof latitude !== 'number' || typeof longitude !== 'number' || isNaN(latitude) || isNaN(longitude)) {
    return false;
  }

  // Calculate distance using Haversine formula
  const R = 6371; // Earth's radius in km
  const dLat = (latitude - zoneLat) * Math.PI / 180;
  const dLon = (longitude - zoneLng) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(zoneLat * Math.PI / 180) * Math.cos(latitude * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceKm = R * c;

  // Return true if within the privacy zone radius
  return distanceKm <= zoneRadiusKm;
};

export default {
  GOOGLE_MAPS_CONFIG,
  MAPBOX_CONFIG,
  DEFAULT_CENTER,
  isInsidePrivacyZone,
};